export default "<div class=\"tag-banner\">\n\t<img [src]=\"imageSource\" />\n</div>\n";